<template>
  <div class="homePage">
    <img src="../assets/Home/banner02.png" alt="" class="banner">
    <div class="currentPanel panel1">
      <div class="chineseTitle">“商旅节省六式”服务准则</div>
      <div class="englishTitle">— SERVICE CRITERIA —</div>
      <div class="serviceStandards">
        <div class="imgList clearfix">
          <img src="../assets/CorporateTravel/1.png" alt="">
          <img src="../assets/CorporateTravel/2.png" alt="">
          <img src="../assets/CorporateTravel/3.png" alt="">
        </div>
        <div class="trait">
          <div class="traitContent">
             省钱
            <i class="symbol">/</i>省时
            <i class="symbol">/</i>省心
          </div>
        </div>
        <div class="describe">
          <p><strong>一式：</strong><span>省钱 商旅优惠价成本<i>节省可达30%</i>，降低企业成本方能实现价值。</span></p>
          <p class="spe"><strong>二式：</strong><span>省钱 <i>30+15</i>结算周期，节省企业现金流成本，减轻企业压力。</span></p>
          <p><strong>三式：</strong><span>省时 <i>60秒</i>迅速响应客户需求，您的时间更为宝贵。</span></p>
          <p class="spe"><strong>四式：</strong><span>省时 <i>7*24*365</i>不间断服务，商旅顾问时刻在您身边。</span></p>
          <p><strong>五式：</strong><span>省心 有温度的管家式<i>1对1定制</i>服务，您的出行是我们的责任。</span></p>
          <p><strong>六式：</strong><span>省心 企业OA<i>系统对接</i>，结算<i>一站式搞定</i>，商旅其实可以很轻松。</span></p>
        </div>
      </div>
    </div>
    <div class="currentPanel panel2">
      <div class="chineseTitle">商旅合规系统</div>
      <div class="englishTitle">— BUSINESS TRAVEL SYSTEM —</div>
      <div class="imgList">
        <div class="div1">
          <img src="../assets/Home/complianceSystes1.png" alt="">
        </div>
        <div class="div2">
          <img src="../assets/Home/complianceSystem2.jpg" alt="">
        </div>
        <div class="div3" :class="{'isShut':isShut}">
          <img src="../assets/Home/complianceSystem3.jpg" alt="">
        </div>
        <div class="div4" :class="{'isShut':isShut}">
          <img src="../assets/Home/complianceSystem4.jpg" alt="">
        </div>
      </div>
    </div>
    <div class="currentPanel panel3">
      <div class="chineseTitle">一站式商旅产品</div>
      <div class="englishTitle">— TRAVEL PRODUCTS —</div>
      <div class="travelProductsList">
        <div class="travelProductsItem" v-for="(item,index) in travelProducts" :key="index">
          <img :src="item.img" alt="">
          <div class="name">{{item.name}}</div>
          <div class="introduction">{{item.introduction}}</div>
        </div>
      </div>
    </div>
    <div class="currentPanel panel4">
      <div class="chineseTitle">代表案例</div>
      <div class="englishTitle">— REPRESENTATIVE CASES —</div>
      <div class="caseList">
        <div class="caseItem" v-for="(item,index) in caseList" :key="index" @click="selectCase">
          <img :src="item.img" alt="">
        </div>
      </div>
    </div>
    <div class="currentPanel panel5">
      <div class="chineseTitle">新闻资讯</div>
      <div class="englishTitle">— NEWS INFORMATION —</div>
      <div class="newsPanel">
        <div class="cover">
          <img src="../assets/Home/test02.png" alt="">
          <div class="introduction">
            <div class="infoTitle">{{firstNews['infoTitle']}}</div>
            <div class="infoBrief">{{firstNews['infoBrief']}}</div>
          </div>
        </div>
        <div class="timeList">
          <img src="../assets/Home/timeLine.png" alt="">
          <img src="../assets/Home/addIcon.png" alt="" @click="goNews">
        </div>
        <div class="newsList">
          <div class="newsItem" v-for="(item,index) in newsList" :key="index" @click="goNewsDetails(item)">
            <div class="topDiv">
              <span class="date">{{item['infoTime']| dateFilter('MM-dd')}}</span>
              <span class="infoTitle">{{item['infoTitle']}}</span>
            </div>
            <div class="footerDiv">
              <span class="date">{{item['infoTime']| dateFilter('yyyy')}}</span>
              <span class="infoBrief">{{item['infoBrief']}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {getHttp} from '../../common/http.js'

  export default {
    name: 'Home',
    data() {
      return {
        isShut: false,
        newsList: [
        	{
        		infoPic: '',
        		infoTime: '2024-08-03',
        		infoTitle: '上海程多多电子商务有限公司超级符号IP角色隆重推出——值得信赖的商旅节省管家',
        		infoBrief: '商旅行业蓬勃发展，市场竞争日益激烈更多企业关注商旅管理的高效性和有效性。',
        	},

        	{
        		infoPic: '',
        		infoTime: '2024-07-30',
        		infoTitle: '商旅头条 ▏降本增效，上海程多多电子商务有限公司助力企业商旅全流程管理',
        		infoBrief: '在不断增长的差旅大数据背后，企业内部的商旅费用管理流程并不简单。差旅成本除了机票酒店等显性成本外，还包含了预订的时间消耗、审批环节、报销流程、票据核查、退改签成本、未使用机票等隐性成本。由于相关信息、数据无从统计，很多企业都忽视了隐性成本。',
        	},

        	{
        		infoPic: '',
        		infoTime: '2024-07-30',
        		infoTitle: '程心旅游 ▏与海见个面！青岛4天3夜定制游',
        		infoBrief: '总要感受一次20°C青岛海风的温柔吧看红砖绿树书写成诗看山海间的潮起潮落怀抱热爱，奔赴一次炽热的海',
        	},

        	{
        		infoPic: '',
        		infoTime: '2024-07-30',
        		infoTitle: '程意酒店 ▏浪漫尽头，海的温柔！威海酒店推荐',
        		infoBrief: '酒店位于素有山东威海“市府后花园”之称的环翠区孙家疃镇，地处北海旅游度假区核心地段金海悦庭，周围还有威高广场、振华商厦、华联、威海百货大楼、银座商城、韩国城、威胜商场刘公岛、仙姑顶、国际海水浴场、葡萄滩海水浴场,褚岛(天然钓鱼台)、锦湖韩亚高尔夫、葡萄滩海公园等景点及配套设施。',
        	},

        ],
        firstNews: {},
        travelProducts: [
          {
            img: require('../assets/Home/airTickets.png'),
            name: '机票',
            introduction: ''
          },
          {
            img: require('../assets/Home/hotel.png'),
            name: '酒店',
            introduction: ''
          },
          {
            img: require('../assets/Home/trainTicket.png'),
            name: '火车票',
            introduction: ''
          },
          {
            img: require('../assets/Home/carRental.png'),
            name: '租车',
            introduction: ''
          },
          {
            img: require('../assets/Home/tourism.png'),
            name: '旅游',
            introduction: ''
          },
          {
            img: require('../assets/Home/visa.png'),
            name: '签证',
            introduction: ''
          }
        ],
        caseList: [
          {
            img: require('../assets/Home/case1.png'),
          },
          {
            img: require('../assets/Home/case2.png'),
          },
          {
            img: require('../assets/Home/case3.png'),
          },
          {
            img: require('../assets/Home/case4.png'),
          },
          {
            img: require('../assets/Home/case5.png'),
          },
          {
            img: require('../assets/Home/case6.png'),
          },
          {
            img: require('../assets/Home/case7.png'),
          },
          {
            img: require('../assets/Home/case8.png'),
          }
        ],
      }
    },
    created() {
      // let _this = this;
      // getHttp(this.constants.INTERFACE_LIST.getInformationList,
      //   {
      //     pageIndex: 1,
      //     pageSize: 4
      //   }).then((res) => {
      //   this.newsList = res;
      //   if (this.newsList.length > 0) {
      //     this.firstNews = this.newsList[0];
      //   }
      // }, (e) => {
      //   _this.$message.error(e.message || '获取内容失败！')
      // })

      this.firstNews = this.newsList[0];

    },
    mounted() {
      window.addEventListener("scroll", this.scrollEvent);
    },
    methods: {
      goNewsDetails(item) {
      	return false;
        this.$router.push({
          name: '资讯详情',
          params: {
            infoId: item['infoId'],
          }
        });
      },
      scrollEvent() {
        if (!!document.documentElement.scrollTop && document.documentElement.scrollTop > 1700) {
          this.isShut = true;
        }
      },
      selectCase() {
        this.$router.push({
          path: '/serviceCase'
        });
      },
      goNews() {
        this.$router.push({
          path: '/news'
        });
      }
    }
  }
</script>

<style lang="less" scoped>
  @import "../css/Home.less";
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue